var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreDrawCardDisabledDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 133,
    viewBox: "0 0 192 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91475 128.412C36.5138 131.468 66.2502 133 96.0062 133C125.748 133.006 155.471 131.483 185.057 128.436L187.07 128.232L187.413 125.987C193.529 86.4909 193.529 46.2866 187.413 6.79052L187.103 4.79032L185.098 4.58622C125.86 -1.52874 66.1521 -1.52874 6.91475 4.58622L4.90124 4.79032L4.59148 6.79052C-1.53049 46.36 -1.53049 86.6379 4.59148 126.207L4.90124 128.208L6.91475 128.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7612 23.3493C15.1066 37.6864 14.2775 52.0899 14.2774 66.503C14.274 80.9093 15.0986 95.3062 16.748 109.637L16.8585 110.612L18.0739 110.778C39.4552 113.741 61.22 113.741 82.6013 110.778L83.6841 110.628L83.7946 109.657C87.1049 80.9636 87.1049 52.0424 83.7946 23.3493L83.6841 22.374L82.6013 22.224C61.1802 19.2587 39.3756 19.2587 17.9545 22.224L16.8717 22.374L16.7612 23.3493Z",
    fill: "#EEEEE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.333 23.3441C105.665 37.7959 104.829 52.3147 104.829 66.843C104.826 81.3646 105.657 95.8767 107.32 110.322L107.431 111.305L108.656 111.472C130.209 114.459 152.147 114.459 173.7 111.472L174.791 111.321L174.903 110.342C178.239 81.4193 178.239 52.2668 174.903 23.3441L174.791 22.361L173.7 22.2098C152.107 19.2208 130.128 19.2208 108.536 22.2098L107.444 22.361L107.333 23.3441Z",
    fill: "#EEEEE4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreDrawCardDisabledDouble);
export default __webpack_public_path__ + "static/media/preDrawCardDisabledDouble.ef0f01160906770f65466112dad3e843.svg";
export { ForwardRef as ReactComponent };